// import React from "react";
// import "./About.css";
// import { useNavigate } from 'react-router-dom';
// import {BiLogoHtml5} from "react-icons/bi";
// import {BiLogoCss3} from "react-icons/bi";
// import {BiLogoJavascript} from "react-icons/bi";
// import {BiLogoReact} from "react-icons/bi";
// import {BiLogoNodejs} from "react-icons/bi";
// import {BiLogoJava} from "react-icons/bi";
// import {BiLogoPython} from "react-icons/bi";
// import {BiLogoFigma} from "react-icons/bi";
// import {SiMui} from "react-icons/si";
// // import Me from "../../Assets/amaan_p_no_bg.png"
// // import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
// // import LaptopChromebookRoundedIcon from '@mui/icons-material/LaptopChromebookRounded';
// // import RecentActorsRoundedIcon from '@mui/icons-material/RecentActorsRounded';
// function About() {

//   const navigate = useNavigate();

//   const handleProjectButtonClick = () => {
//     navigate('/projects');
//   };
//   return (
//     <section id="about">
//       <h1>Get To Know Me</h1>
//       <div class="about__card">
//         <div class="me-1 about__card-1 card-1">
//           <div class="about__circle circle-1" style={{ backgroundImage: 'url("/Assets/boy-2.png")' }}>
//             <span>About</span>
//           </div>

//           <div class="about__card-1-inner me-info">
//             <p>
//               Hey there! I'm <span style={{fontWeight:"bold"}}>Amaan</span>, a passionate <span style={{fontWeight:"bold"}}>frontend web developer</span> from
//               India. I thrive on continuous learning and have a genuine flair
//               for creativity and discovering new concepts.
//             </p>
//             <button>Know More</button>
//           </div>
//         </div>

//         <div class="me-1 about__card-1 card-2">
//           <div class="about__circle circle-2" style={{ backgroundImage: 'url("/Assets/skill_1.png")' }}>
//             <span>Skills</span>
//           </div>

//           <div class="about__card-1-inner skills__inner">
//             <BiLogoHtml5 className="html"/>
//             <BiLogoCss3 className="css"/>
//             <BiLogoJavascript className="js"/>
//             <BiLogoReact className="react"/>
//             <BiLogoNodejs className="node"/>
//             <BiLogoJava className="java"/>
//             <BiLogoPython className="python"/>
//             <BiLogoFigma className="figma"/>
//             <SiMui className="mui"/>
//             {/* <SiPostman/> */}
//           </div>
//         </div>
//         <div class="me-1 about__card-1 card-3">
//           <div class="about__circle circle-3" style={{ backgroundImage: 'url("/Assets/project.png")' }}>
//             <span>Projects</span>
//           </div>

//           <div class="about__card-1-inner project_card_inner">
//             <img src='/Assets/project_2.svg' alt="img"></img>
//             <p>Feel free to check out my work! 🚀</p>
//             <button onClick={handleProjectButtonClick}>View</button>
//           </div>
//         </div>

//         {/* <div class="me about__card-1">
//           <div class="about__circle">
//           </div>
          
//           <div class="about__card-1-inner">
//           </div>
//         </div> */}
//       </div>
//     </section>
//   );
// }

// export default About;


import React from "react";
import "./About.css";
import { useNavigate } from 'react-router-dom';
import {BiLogoHtml5} from "react-icons/bi";
import {BiLogoCss3} from "react-icons/bi";
import {BiLogoJavascript} from "react-icons/bi";
import {BiLogoReact} from "react-icons/bi";
import {BiLogoNodejs} from "react-icons/bi";
import {BiLogoJava} from "react-icons/bi";
import {BiLogoPython} from "react-icons/bi";
import {BiLogoFigma} from "react-icons/bi";
import {SiMui} from "react-icons/si";
// import Me from "../../Assets/amaan_p_no_bg.png"
// import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
// import LaptopChromebookRoundedIcon from '@mui/icons-material/LaptopChromebookRounded';
// import RecentActorsRoundedIcon from '@mui/icons-material/RecentActorsRounded';
function About() {

  const navigate = useNavigate();

  const handleProjectButtonClick = () => {
    navigate('/projects');
  };

  const handleKnowMoreClick = () => {
    navigate('/about');
  };
  return (
    <section id="about">
      <h1>Get To Know Me</h1>
      <div class="about__card">
        <div class="me-1 about__card-1 card-1">
          <div class="about__circle circle-1" style={{ backgroundImage: 'url("/Assets/boy-2.png")' }}>
            <span>About</span>
          </div>

          <div class="about__card-1-inner me-info">
            <p>
              Hey there! I'm <span style={{fontWeight:"bold"}}>Amaan</span>, a passionate <span style={{fontWeight:"bold"}}>frontend web developer</span> from
              India. I thrive on continuous learning and have a genuine flair
              for creativity and discovering new concepts.
            </p>
            <button onClick={handleKnowMoreClick}>Know More</button>
          </div>
        </div>

        <div class="me-1 about__card-1 card-2">
          <div class="about__circle circle-2" style={{ backgroundImage: 'url("/Assets/skill_1.png")' }}>
            <span>Skills</span>
          </div>

          <div class="about__card-1-inner skills__inner">
            <BiLogoHtml5 className="html"/>
            <BiLogoCss3 className="css"/>
            <BiLogoJavascript className="js"/>
            <BiLogoReact className="react"/>
            <BiLogoNodejs className="node"/>
            <BiLogoJava className="java"/>
            <BiLogoPython className="python"/>
            <BiLogoFigma className="figma"/>
            <SiMui className="mui"/>
            {/* <SiPostman/> */}
          </div>
        </div>
        <div class="me-1 about__card-1 card-3">
          <div class="about__circle circle-3" style={{ backgroundImage: 'url("/Assets/project.png")' }}>
            <span>Projects</span>
          </div>

          <div class="about__card-1-inner project_card_inner">
            <img src='/Assets/project_2.svg' alt="img"></img>
            <p>Feel free to check out my work! 🚀</p>
            <button onClick={handleProjectButtonClick}>View</button>
          </div>
        </div>

        {/* <div class="me about__card-1">
          <div class="about__circle">
          </div>
          
          <div class="about__card-1-inner">
          </div>
        </div> */}
      </div>
    </section>
  );
}

export default About;